import '../App.css';
import 'animate.css';
import screen1 from '../assets/images/rettich-screen1.png';
import screen2 from '../assets/images/rettich-screen2.png';

function ProjectTemplate() {
  return (
    <div className="App">
      <div className="home-container">
        <h1 className="scroll-down-arrow animate__animated animate__fadeInDown animate__slow animate__delay-1s">↓</h1>
        <h5 className="animate__animated animate__fadeIn animate__slow animate__delay-1s">a.mcknight<span className="grey">.digital</span></h5>
        <a href="/">
          <h5 className="animate__animated animate__fadeIn animate__slow animate__delay-1s">← return home</h5>
        </a>
        <h1 className="animate__animated animate__fadeInUp animate__slow">Rettich Productions</h1>
        <p className="animate__animated animate__fadeIn animate__slow animate__delay-2s">ReactJS, JavaScript, CSS, Bootstrap, and JSX.</p>
        
        <div className="about animate__animated animate__fadeInUp animate__slower animate__delay-2s">
          <h3>
           Project Overview:
          </h3>
          <h2>
            Rettich Productions is a full-service live event production company, based in Northern Cincinnati, Ohio. Our team of experts has over 60 years in combined experience with Live Event Production.
          </h2>
          <h2>
            McKnight Digital worked with them to build a new site. After launching the site, our customer saw an improvement in SEO rankings!* We also worked with them to create a site that fit their needs and their customers' needs as well.
          </h2>
        </div>
        <div className="screenshots">
          <img src={screen1} alt="Screen shot of program."></img>
          <img src={screen2} alt="Screen shot of program."></img>
        </div>
        <div className="about">
          <h3>
           Project Highlights:
          </h3>
          <h2>
            <li>Responsive CSS site</li>
            <li>Built with React JavaScript tooling</li>
            <li>Deployed to Netlify for quick CI / CD</li>           
          </h2>
        </div>
      
        <h3>View the Site at: <a target="_blank"  rel="noreferrer" href="https://www.rettich.com">www.rettich.com</a></h3>
       
        <h5 className="grey home-link">view privacy and site license —</h5>
      </div>

      
      
    </div>
  );
}

export default ProjectTemplate;
